import "./GlJournalHome.scss";
import React, { useEffect, useState } from "react";
import CircularButton, { CustomButtonMenu, CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader, ScaleLoader } from "react-spinners";
import { FaReceipt } from "react-icons/fa";
import { IoClose, IoDocumentText, IoDocumentTextSharp } from "react-icons/io5";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import { MdArrowBackIos, MdClose, MdAdd } from "react-icons/md";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import ExportToExcelButton from "../../../components/exportToExcelButton/ExportToExcelButton";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { fetchClientsBySearch } from "../../../utils/genericFunctions";
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar";

const GlJournalHome = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [journals, setJournals] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["gl-journal"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const showBack = location.state?.showBack || "N";
  const [disableOtherFields, setDisableOtherFields] = useState(false);
  const [filterFmDate, setFilterFmDate] = useState(new Date());
  const [filterToDate, setFilterToDate] = useState(new Date());
  const [filterHdNo, setFilterHdNo] = useState(null);
  const [filterClient, setFilterClient] = useState(null);
  const [filterBankAccount, setFilterBankAccount] = useState(null);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterCurrency, setFilterCurrency] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [bankAccounts, setBankAccounts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const [filterJournalType, setFilterJournalType] = useState(null);
  const [journalTypes, setJournalTypes] = useState([]);

  const [filterJournalSource, setFilterJournalSource] = useState(null);
  const [journalSources, setJournalSources] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };

  const filteredJournalsData = journals.filter(
    (item) =>
      item?.hd_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.hd_ref_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.hd_doc_no?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const slicedJournalsData = filteredJournalsData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleSearchJournals = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/glJournal/search", { search_input: searchTerm });
        setJournals(res.data);
      } else {
        fetchJournals();
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error searching data:", error);
    }
  };

  const fetchJournals = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/glJournal/findAll", { result_limit: 5 });
      setJournals(res.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const fetchJournalSources = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Journal Sources" });
      const options = res.data.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));
      setJournalSources(options);
    } catch (error) {
      console.error("Error fetching journal sources :", error);
    }
  };

  const fetchJournalTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Journal Types" });
      const options = res.data.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));
      setJournalTypes(options);
    } catch (error) {
      console.error("Error fetching journal types :", error);
    }
  };


  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      let options = res.data.map((currency) => ({
        value: currency?.cur_code,
        label: currency?.cur_name,
      }));
      options.unshift({ value: "All", label: "All" });
      setCurrencies(options);
      setFilterCurrency(options[0]);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const options = ["All", "New", "Validated", "Approved", "Cancelled", "In-Approval"].map((mode) => ({
        value: mode,
        label: mode,
      }));
      setStatuses(options);
      setFilterStatus({
        value: "All",
        label: "All",
      });
    } catch (error) {
      console.error("Error fetching journal modes :", error);
    }
  };

  const setDates = () => {
    try {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // Beginning of the year
      const beginningOfYear = new Date(currentYear, 0, 1);
      beginningOfYear.setFullYear(currentYear); // Set full year again to handle leap years
      const formattedBeginningOfYear = beginningOfYear
        .toISOString()
        .split("T")[0];

      // End of the year
      const endOfYear = new Date(currentYear + 1, 0, 0);
      const formattedEndOfYear = endOfYear.toISOString().split("T")[0];

      // Beginning of the month
      const beginningOfMonth = new Date(currentYear, currentMonth, 1);
      // console.log(`Begining of the month ${beginningOfMonth}`)
      const formattedBeginningOfMonth = beginningOfMonth
        .toISOString()
        .split("T")[0];

      // End of the month
      const endOfMonth = new Date(currentYear, currentMonth + 1, 0);
      endOfMonth.setDate(endOfMonth.getDate() + 1); // Add one day to get the actual end of the month
      const formattedEndOfMonth = endOfMonth.toISOString().split("T")[0];

      // Formatting current date and one year later
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      const oneYearLater = new Date(currentDate);
      oneYearLater.setFullYear(currentYear + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split("T")[0];

      // Set these values to your state or do whatever you want with them
      setFilterFmDate(formattedBeginningOfMonth);
      setFilterToDate(formattedEndOfMonth);
    } catch (error) {
      console.log(error);
    }
  };



  const menus = [
    {
      _id: "home",
      title: t('home'),
    },
    {
      _id: "list",
      title: t('list'),
    },
  ];

  const handleGetJournalListing = async () => {
    try {
      setIsProcessing(true);
      const res = await newRequest.post("/glJournal/journalsListing", {
        hd_no: filterHdNo,
        date_fm: filterFmDate,
        date_to: filterToDate,
        hd_biz_unit: !filterBranch || filterBranch?.value === "All" ? "" : filterBranch?.value,
        hd_status: !filterStatus || filterStatus.value === "All" ? "" : filterStatus?.value,
        hd_type: !filterJournalType || filterJournalType.value === "All" ? "" : filterJournalType?.value,
        hd_source: !filterJournalSource || filterJournalSource.value === "All" ? "" : filterJournalSource?.value,
        hd_cur_code: !filterCurrency || filterCurrency?.value === "All" ? "" : filterCurrency?.value,
      });
      console.log(`journalsListing  ${JSON.stringify(res.data, null, 2)}`);
      if (res.data?.list) {
        setJournals(res.data?.list);
      } else {
        setJournals([]);
      }
      setIsProcessing(false);
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
    }
  };

  const exportConfig = [
    { key: "hd_no", label: "Journal No.", format: "s" },
    { key: "hd_type", label: "Type", format: "s" },
    { key: "hd_gl_date", label: "GL Date", format: "d" },
    { key: "hd_status", label: "Status", format: "s" },
    { key: "hd_narration", label: "Narration", format: "s" },
    { key: "hd_mode", label: "Mode", format: "s" },
    { key: "hd_ref_no", label: "Ref No", format: "s" },
    { key: "hd_paying_for", label: "Purpose", format: "s" },
    { key: "bizunit_name_xx", label: "Branch Name", format: "s" },
    { key: "hd_biz_unit", label: "Branch Code", format: "s" },
    { key: "bank_ac_no_xx", label: "Account From No", format: "s" },
    { key: "bank_ac_name_xx", label: "Account From Name", format: "s" },
    { key: "hd_chq_no", label: "Cheque No", format: "s" },
    { key: "hd_chq_date", label: "Cheque Date", format: "s" },
    { key: "client_name_xx", label: "Client Name", format: "s" },
    { key: "client_code_xx", label: "Client Code", format: "s" },
    { key: "hd_cur_code", label: "Currency", format: "s" },
    { key: "hd_cur_rate", label: "Rate", format: "n" },
    { key: "hd_fc_amount", label: "Amount FC", format: "n" },
    { key: "hd_lc_amount", label: "Amount LC", format: "n" },
    { key: "allocated_fc_amount_xx", label: "Allocated FC", format: "n" },
    { key: "allocated_lc_amount_xx", label: "Allocated LC", format: "n" },
  ];

  useEffect(() => {
    fetchJournals();
    fetchJournalSources();
    fetchJournalTypes();
    fetchBranches();
    fetchCurrencies();
    fetchStatuses();
    setDates();
    setSelectedMenu(menus[0]);
  }, []);


  return (
    <motion.div
      className="gl-journal-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="gl-journal-home-main-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <div className="list-navbar-left">
                <div className="glHeroIcon">
                  <IoDocumentText />
                </div>
                <div className="glHeroTitle">{t("journals")}</div>
              </div>
              <div className="list-navbar-right">
                <div className="home-menus-wrapper">
                  {menus?.map((row, index) => (
                    <React.Fragment key={row._id}>
                      <span style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                        <CustomButtonMenu
                          className="single-menu"
                          currentButton={selectedMenu?._id === row?._id}
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              setSelectedMenu(row);
                              if (row?._id === "list") {
                                await fetchJournalTypes();
                                await fetchJournalSources();
                                await fetchBranches();
                                await fetchCurrencies();
                                await fetchStatuses();
                                setDates();
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          {row?.title}
                        </CustomButtonMenu>
                      </span>
                      {index < menus.length - 1 && <span className="separator-v" />}
                    </React.Fragment>
                  ))}
                </div>
                <span className="separator-v" />
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run journals reports"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  endIcon={<RefreshIcon />}
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  onClick={fetchJournals}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  borderRadiusType="both"
                  variant="tint"
                  color="#0ea5a4"
                  tooltip={"New journal"}
                  iconPosition="end"
                  endIcon={<MdAdd />}
                  onClick={() => navigate("/journal/new")}
                >
                  {t('newJournal')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            {selectedMenu?._id === "home" && (
              <div className="glHome">
                {/* HERO */}
                <div className="glHero">
                  <div className="glHeroSub">{t("journalsHomeDesc")}</div>
                  {/* Search */}
                  <div className="homeSearch">
                    <FiSearch className="homeSearchIcon" />
                    <input
                      className="homeSearchInput"
                      type="text"
                      placeholder="Search Journals by Number, Ref Number or Document Number..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearchJournals();
                      }}
                    />
                    {searchTerm?.length > 0 ? (
                      <MdClose
                        className="homeSearchClear"
                        onClick={() => {
                          try {
                            fetchJournals();
                            setSearchTerm("");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                    ) : (
                      <span className="homeSearchClearPlaceholder" />
                    )}
                  </div>
                </div>

                {/* GRID */}
                <div className="glCardsGrid">
                  {slicedJournalsData?.map((journal) => {
                    const status = (journal?.hd_status || "").toUpperCase();
                    const isNew = status === "NEW";
                    const isApproved = status === "APPROVED";
                    const isCancelled = status === "CANCELLED";

                    const drAmount = numeral(journal?.total_debit_fc_xx || 0).format("0,0.00");
                    const crAmount = numeral(journal?.total_credit_fc_xx || 0).format("0,0.00");
                    const controlAmount = numeral(journal?.control_amount || 0).format("0,0.00");


                    return (
                      <div
                        key={journal?._id}
                        className={`glCard ${isNew ? "isNew" : ""} ${isApproved ? "isApproved" : ""} ${isCancelled ? "isCancelled" : ""}`}
                        onClick={() => navigate(`/journal/${journal._id}`)}
                      >
                        {/* top */}
                        <div className="glCardTop">
                          <div className="glCardBadge"><FaReceipt /></div>
                          <div className="glCardTopMeta">
                            <div className="glCardNo">{journal?.hd_no}</div>
                            <div className="glCardName">{journal?.hd_type}</div>
                            <div className="glCardTiny">
                              {journal?.bizunit_name_xx}
                            </div>
                          </div>

                          <div className="glCardTopRight">
                            <span className={`glStatusPill ${status}`}>
                              {status || "STATUS"}
                            </span>
                          </div>
                        </div>

                        {/* divider */}
                        <div className="glDivider" />

                        {/* amount block */}
                        <div className="glAmountRow">
                          <div className="glAmountLabel">
                            <div className="glAmountTitleWrap">
                              <div className="glAmountTitle">{t('amount')}</div>
                              <div className="glAmountTitle">{`[${journal?.hd_cur_code || ""}]`}</div>
                            </div>
                          </div>

                          <div className="glAmountValueWrap">
                            <div className="glAmountValue neg">
                              {drAmount}
                            </div>
                            <div className="glAmountHint neg">
                              {t('dr').toUpperCase()}
                            </div>
                          </div>
                          <div className="glAmountValueWrap">
                            <div className="glAmountValue ok">
                              {crAmount}
                            </div>
                            <div className="glAmountHint ok">
                              {t('cr').toUpperCase()}
                            </div>
                          </div>
                        </div>

                        {/* meta row */}
                        <div className="glMetaRow">
                          <div className="glMetaCol" style={{ flex: "1.5" }}>
                            <div className="glMetaLabel">{t('source').toUpperCase()}</div>
                            <div className="glMetaValue">{`${journal?.hd_source || "-"}`}</div>
                          </div>

                          <div className="glMetaCol" style={{ flex: "1", textAlign: "right" }}>
                            <div className="glMetaLabel">{t('date').toUpperCase()}</div>
                            <div className="glMetaValue">
                              {journal?.hd_gl_date ? moment(journal?.hd_gl_date).format("DD-MMM-YYYY") : "-"}
                            </div>
                          </div>
                        </div>

                        {/* footer */}
                        <div className="glCardFooter">
                          <div className="glFooterLeft">
                            {/* <div className="glOrgDot" /> */}
                            <InitialsAvatar
                              name={journal?.updated_by_name_xx}
                              size={20}
                              currentTheme={currentTheme}
                            />
                            <div className="glOrgName">{journal?.updated_by_name_xx || "Bima Go"}</div>
                          </div>

                          <div className="glFooterRight">
                            <div className="glFooterTiny">{journal?.time_ago_xx || ""}</div>
                            <div className="glFooterTiny">{`${journal?.total_lines_xx > 1 ? `${journal?.total_lines_xx} ${t('lines')}` : `${journal?.total_lines_xx} ${t('line')}`}`}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Create New Journal Tile */}
                  <div
                    className="glCardCreate"
                    onClick={() => navigate(`/journal/new`)}
                  >
                    <div className="glCreatePlus">+</div>
                    <div className="glCreateText">{t('createNewJournal')}</div>
                  </div>
                </div>

                {/* Floating help button (keeps your existing help overlay logic) */}
                {/* <div className="glFloatingHelp">
                  <button className="overlay-button" onClick={handleOpenOverlay}>
                    ?
                  </button>
                </div> */}
              </div>
            )}

            {selectedMenu?._id === "list" &&
              <motion.div
                className="filter-wrapper"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1 } }}
                exit={{ opacity: 0, transition: { duration: 1 } }}
              >
                <ExpandableComponent
                  title={<h3 className="normal-title" style={{ alignSelf: "center" }}>{t('pleaseEnterSearch')}</h3>}
                  subtitle={""}
                  defaultExpanded={true}
                >
                  <div className="content-wrapper-selection">
                    <div className="filter">
                      <div className="left">
                        <div className="input-item-with-label">
                          <label
                            htmlFor="fm_date"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('from').toUpperCase()}
                          </label>
                          <input
                            id="fm_date"
                            name="fm_date"
                            type="date"
                            placeholder={t('from').toUpperCase()}
                            value={filterFmDate}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              if (e.target.value) {
                                const formattedFmDate = moment(e.target.value).format("YYYY-MM-DD");
                                setFilterFmDate(formattedFmDate);
                              }
                            }}
                            disabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label
                            htmlFor="to_date"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('to').toUpperCase()}
                          </label>
                          <input
                            id="to_date"
                            name="to_date"
                            type="date"
                            placeholder={t('to').toUpperCase()}
                            value={filterToDate}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              if (e.target.value) {
                                const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
                                setFilterToDate(formattedToDate);
                              }
                            }}
                            disabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label
                            htmlFor="filterHdNo"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('journalNo').toUpperCase()}
                          </label>
                          <input
                            id="filterHdNo"
                            name="filterHdNo"
                            type="text"
                            placeholder={t('journalNo').toUpperCase()}
                            value={filterHdNo}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            onChange={(e) => {
                              try {
                                setFilterHdNo(e.target.value);
                                if (e.target.value) {
                                  setDisableOtherFields(true);
                                } else {
                                  setDisableOtherFields(false);
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') handleGetJournalListing();
                            }}
                          />
                        </div>
                      </div>
                      <div className="center">
                        <div className="input-item-with-label">
                          <label htmlFor="journalSource" style={{ width: "130px" }}>
                            {t('source').toUpperCase()}
                          </label>
                          <Select
                            id="journalSource"
                            name="journalSource"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterJournalSource}
                            onChange={(selectedOption) => setFilterJournalSource(selectedOption)}
                            options={journalSources}
                            isSearchable={true}
                            isClearable
                            placeholder={t('source').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="journalType" style={{ width: "130px" }}>
                            {t('type').toUpperCase()}
                          </label>
                          <Select
                            id="journalType"
                            name="journalType"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterJournalType}
                            onChange={(selectedOption) => setFilterJournalType(selectedOption)}
                            options={journalTypes}
                            isSearchable={true}
                            isClearable
                            placeholder={t('type').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="client" style={{ width: "130px" }}>
                            {t('source').toUpperCase()}
                          </label>
                          <AsyncSelect
                            id="client"
                            name="client"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="350px"
                            value={filterClient}
                            onChange={(selectedOption) => setFilterClient(selectedOption)}
                            loadOptions={fetchClientsBySearch}
                            isSearchable={true}
                            isClearable
                            placeholder={t('client').toUpperCase()}
                            noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                      </div>
                      <div className="right">
                        <div className="input-item-with-label biz_unit">
                          <label htmlFor="biz_unit" style={{ width: "100px" }}>
                            {t('bizUnit').toUpperCase()}
                          </label>
                          <Select
                            id="biz_unit"
                            name="biz_unit"
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterBranch}
                            onChange={(selectedOption) => setFilterBranch(selectedOption)}
                            options={branches}
                            isSearchable={true}
                            placeholder={t('bizUnit').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="currency_code" style={{ width: "100px" }}>
                            {t('currency').toUpperCase()}
                          </label>
                          <Select
                            id="currency_code"
                            name="currency_code"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterCurrency}
                            onChange={(selectedOption) => setFilterCurrency(selectedOption)}
                            options={currencies}
                            isSearchable={true}
                            placeholder={t('currency').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="status" style={{ width: "100px" }}>
                            {t('status').toUpperCase()}
                          </label>
                          <Select
                            id="status"
                            name="status"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={filterStatus}
                            onChange={(selectedOption) => setFilterStatus(selectedOption)}
                            options={statuses}
                            isSearchable={true}
                            placeholder={t('status').toUpperCase()}
                            isDisabled={disableOtherFields}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", margin: "15px 0px 5px 0px" }}>
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType="both"
                        variant="tint"
                        color="#8BC34A"
                        width={"300px"}
                        endIcon={<PageviewOutlinedIcon />}
                        onClick={handleGetJournalListing}
                      >
                        {t('run').toUpperCase()}
                      </CustomLoadingButton>
                    </div>
                  </div>
                </ExpandableComponent>
                <div className="filter-wrapper-results">
                  <div className="results-wrapper">
                    <div className="results-wrapper-navbar">
                      <div className="navbar-left">
                        <div className="homeSearch" style={{ width: "90%" }}>
                          <FiSearch className="homeSearchIcon" />
                          <input
                            className="homeSearchInput"
                            type="text"
                            placeholder={t('search')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          {searchTerm.length > 0 && (
                            <MdClose
                              onClick={() => setSearchTerm("")}
                              className="homeSearchClear"
                            />
                          )}
                        </div>
                      </div>
                      <div className="navbar-right">
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            borderRadiusType="both"
                            variant="tint"
                            color="#0f766e5d"
                            endIcon={<RefreshIcon />}
                            onClick={handleGetJournalListing}
                          >
                            {t('refresh')}
                          </CustomLoadingButton>
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            borderRadiusType="both"
                            variant="tint"
                            color="#2563EB"
                            tooltip="Run journals reports"
                            endIcon={<IoDocumentTextSharp />}
                            onClick={() => navigate("/reports/gl-reports", { state: { showBack: "Y" } })}>
                            {t('reports')}
                          </CustomLoadingButton>
                          {filteredJournalsData?.length > 0 &&
                            <ExportToExcelButton
                              data={filteredJournalsData}
                              exportConfig={exportConfig}
                              fileName="Journals.xlsx"
                              currentTheme={currentTheme}
                              borderRadiusType="right"
                            />}
                        </div>
                      </div>
                    </div>

                    <div className="table-content">
                      {slicedJournalsData?.length > 0 &&
                        <div className="table-content">
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                            className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableBody className="tablebody">
                                {slicedJournalsData?.map((journal, index) => (
                                  <TableRow
                                    key={journal._id}
                                    className="tablerow"
                                    onClick={() => navigate(`/journal/${journal._id}`)}
                                  >
                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                      {page * rowsPerPage + index + 1}
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                      <span className="sub-title">{journal?.hd_no}</span>
                                      <span className="sub-title xrsmall" style={{ textAlign: "right", fontWeight: "bold", fontSize: "10px", color: "#f44336" }}>[{journal?.hd_cur_code}]</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                      <span className="sub-title two-lines">{`${journal?.hd_narration}`}</span>
                                    </TableCell>

                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                      <span className="sub-title boldsmall">{t('debit')}</span>
                                      <span className="sub-title boldsmall">{numeral(journal?.total_debit_fc_xx).format("0,0.00")}</span>
                                    </TableCell>

                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                      <span className="sub-title boldsmall">{t('credit')}</span>
                                      <span className="sub-title boldsmall">{numeral(journal?.total_credit_fc_xx).format("0,0.00")}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                      <span className="sub-title">{journal?.hd_type}</span>
                                      <span className="sub-title"> {journal?.bizunit_name_xx}</span>
                                    </TableCell>
                                    <TableCell className="table-cell center" style={{ maxWidth: "120px" }}>
                                      <span> {moment(journal?.hd_gl_date).format("DD-MMM-YYYY")}</span>
                                      <span className={`status small ${journal?.hd_status}`}> {journal?.hd_status}  </span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                      <WorkedOnBy name={journal?.updated_by_name_xx} photoUrl={journal?.updated_by_photo_url_xx} time_ago_xx={journal?.time_ago_xx} showTitle={false} />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            {filteredJournalsData.length > rowsPerPage &&
                              <TablePagination
                                rowsPerPageOptions={[5]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                component="div"
                                count={filteredJournalsData.length}
                                page={page}
                                onPageChange={handleChangePage}
                              />}
                          </TableContainer>
                        </div>}
                    </div>
                  </div>
                </div>
              </motion.div>}
          </motion.div>

          {isOverlayOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span>{t('help').toUpperCase()}</span>
                  <span onClick={() => setIsOverlayOpen(false)}>
                    <IoClose
                      style={{
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                        borderRadius: "50%",
                      }}
                    />
                  </span>
                </div>
                <div className="overlay-content">
                  <VideoPlayer videoUrl="https://www.youtube.com/embed/PPCfDe8TfJQ" />
                </div>
                <div className="overlay-actions">
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docType: "AllJournals",
                  docId: "1",
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: "",
                  filters: {
                    hd_no: filterHdNo,
                    date_fm: filterFmDate,
                    date_to: filterToDate,
                    hd_biz_unit: !filterBranch || filterBranch?.value === "All" ? "" : filterBranch?.value,
                    hd_ac_no: !filterBankAccount || filterBankAccount.value === "All" ? "" : filterBankAccount?.value,
                    hd_status: !filterStatus || filterStatus.value === "All" ? "" : filterStatus?.value,
                    hd_type: !filterJournalSource || filterJournalSource.value === "All" ? "" : filterJournalSource?.value,
                    hd_cur_code: !filterCurrency || filterCurrency?.value === "All" ? "" : filterCurrency?.value,
                    hd_ent_code: !filterClient || filterClient?.value === "All" ? "" : filterClient?.value,
                  }
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default GlJournalHome;
